import { loginWithPasskey, registerPasskey } from './passkey-client';

export function renderLoginPage(root: HTMLElement, onAuthed: () => void) {
  root.innerHTML = `
    <div class="stack">
      <h1>Jeffrey Finance</h1>
      <p class="muted">Log in with Face ID, or register this device if it's your first time.</p>
      <button id="login-btn">Log in with Face ID</button>
      <hr />
      <p class="muted">First time on this device?</p>
      <input id="display-name" placeholder="Your name (Liam / wife's name)" />
      <input id="device-name" placeholder="Device name (e.g. iPhone 16)" />
      <button id="register-btn">Register this device</button>
      <p id="status" class="muted"></p>
    </div>
  `;

  const status = root.querySelector<HTMLElement>('#status')!;

  root.querySelector<HTMLButtonElement>('#login-btn')!.addEventListener('click', async () => {
    status.textContent = 'Waiting for Face ID…';
    try {
      await loginWithPasskey();
      onAuthed();
    } catch (e) {
      status.textContent = `Login failed: ${(e as Error).message}`;
    }
  });

  root.querySelector<HTMLButtonElement>('#register-btn')!.addEventListener('click', async () => {
    const displayName = root.querySelector<HTMLInputElement>('#display-name')!.value.trim();
    const deviceName = root.querySelector<HTMLInputElement>('#device-name')!.value.trim();
    if (!displayName || !deviceName) {
      status.textContent = 'Name and device name are required.';
      return;
    }
    status.textContent = 'Registering passkey with Face ID…';
    try {
      await registerPasskey(displayName, deviceName);
      status.textContent = 'Registered. Now tap “Log in with Face ID”.';
    } catch (e) {
      status.textContent = `Registration failed: ${(e as Error).message}`;
    }
  });
}
